/* eslint-disable react-hooks/exhaustive-deps */
import React, { Dispatch, useEffect, useState } from 'react';
import Pagination from "rc-pagination";
import {dateFormatOptions} from "../../common/dateFormatterConfig";
import {locale} from "../../common/table/paginatorConfig";
import {IDocumentRow, IDocumentRowSortFields} from "../../models/document-row";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { SortDirection } from 'common/interfaces/IPageResponse';
import { SortIcons } from 'components/SortIcons/SortIcons';
import { Button, Form, Spinner } from 'react-bootstrap';
import { getPriceWithoutVAT, getVatAmount } from 'helpers';
import moment from 'moment';

export function DocumentRowTable(props: any) {

    const [sortedByField, setSortedByField]: [IDocumentRowSortFields, Dispatch<any>] = useState(IDocumentRowSortFields.DOCUMENT_DATE);
    const [sortDirection, setSortDirection]: [SortDirection, Dispatch<any>] = useState(SortDirection.DESC);

    const documentRows: Array<IDocumentRow> = (props.documentRows && props.documentRows.content) || [];
    const pageResponse = props.documentRows;
    const isRequesting = props.isRequesting;

    useEffect(() => {
        props.onSortChange(sortedByField, sortDirection);
    }, [sortedByField, sortDirection]);

    const handleSortClick = (currentSortColumn: IDocumentRowSortFields) => {
        if (sortedByField.match(currentSortColumn)) {
        setSortDirection(sortDirection === SortDirection.DESC ? SortDirection.ASC : SortDirection.DESC);
        } else {
        setSortDirection(SortDirection.ASC);
        setSortedByField(currentSortColumn);
        }
    };



    const tableRows = documentRows.map((documentRow: IDocumentRow, index) => {
        const isFirstRowOfDocument = documentRows[index - 1]?.remoteDocumentId !== documentRow.remoteDocumentId;
        const borderStyle = !isFirstRowOfDocument ? { border: 'none'} : undefined;

        return (
            <tr key={'row-' + documentRow.remoteDocumentId + '-' + index} style={{ borderBottom: 'none' }}>
                <td style={borderStyle}>
                    { isFirstRowOfDocument && <Form.Check
                    id={`doc-check-${documentRow.remoteDocumentId}`}
                    custom
                    type="checkbox"
                    label=""
                    className='mt-2 mb-n1'
                    onChange={(event: any) => props.onRowSelect(documentRow, event.target.checked)}
                    checked={props.selectedRows?.some((c: IDocumentRow) => c.remoteDocumentId === documentRow.remoteDocumentId)}
                /> }
                </td>
                <td style={borderStyle}>
                    { isFirstRowOfDocument &&
                    <>
                        <span className="d-md-inline d-none">{documentRow.documentNumber}</span>
                        <span className="d-md-none d-inline">{documentRow.documentNumber.split("-", 2)[0]}</span>
                    </>
                    }
                </td>
                <td style={borderStyle}>
                    {documentRow.documentDateCreated ? new Intl.DateTimeFormat('et', dateFormatOptions).format(new Date(documentRow.documentDateCreated)) : ""}
                </td>
                <td style={borderStyle}>
                    {documentRow.locationName}
                </td>
                <td style={borderStyle}>
                    <span className="d-md-inline d-none">{documentRow.remoteCardId}</span>
                    <span className="d-md-none d-inline">
                        <OverlayTrigger delay={250}
                                        overlay={
                                            <Tooltip id={`tooltip-card-${documentRow.remoteDocumentId}`}>
                                                <p style={{margin: '3px'}}>{documentRow.remoteCardId}</p>
                                            </Tooltip>} placement={"auto"}>
                            <span>
                                {documentRow.remoteCardId ?
                                    "…" + documentRow.remoteCardId.substring(documentRow.remoteCardId.length - 8, documentRow.remoteCardId.length)
                                    : ''}
                            </span>
                        </OverlayTrigger>
                    </span>
                </td>
                <td style={borderStyle}>
                    {documentRow.cardName}
                </td>
                <td style={borderStyle}>{documentRow.vehicleNumber}</td>
                <td style={borderStyle}>{documentRow.vehicleMileage}</td>
                <td style={borderStyle}>
                    <span className="d-md-inline d-none">{documentRow.productName}</span>
                    <span className="d-md-none d-inline">
                        <OverlayTrigger delay={250}
                                        overlay={
                                            <Tooltip id={`tooltip-product-name-${documentRow.remoteDocumentId}`}>
                                                <p style={{margin: '3px'}}>{documentRow.productName}</p>
                                            </Tooltip>} placement={"auto"}>
                        <span className="text-nowrap">{documentRow.productName.substring(0, 8) + "…"}</span>
                        </OverlayTrigger>
                    </span>
                </td>
                <td style={borderStyle}>
                    {documentRow.price}
                </td>
                <td style={borderStyle}>
                    {documentRow.productQuantity}
                </td>
                <td style={borderStyle}>
                    {documentRow.productAmountSum}
                </td>
                <td style={borderStyle}>
                    {documentRow.productAmountSum !== null ? getPriceWithoutVAT(documentRow.productAmountSum, moment(documentRow.documentDateCreated)) : ''}
                </td>
                <td style={borderStyle}>
                    {documentRow.productAmountSum !== null ? getVatAmount(documentRow.productAmountSum, moment(documentRow.documentDateCreated)) : ''}
                </td>
                <td style={borderStyle}>
                { isFirstRowOfDocument && <Button size="sm" variant="link" className="d-flex align-items-center ml-1 btn-outline-icon position-relative" onClick={() => props.getDocumentRowFile(documentRow)}>
                    {
                        props.downloadingDocumentPdf === documentRow.remoteDocumentId ?
                        <Spinner size="sm" animation="border" /> :
                        <div className="" style={{ color: 'black' }}>
                            <div className='icon__file action-icon mb-2 icon--16' />
                            <span style={{ position: 'absolute', fontSize: '8px', bottom: '0', left: '4px'}}>PDF</span>                            
                        </div>
                    }
                </Button>}
                </td>
            </tr>
        )
    }

    );
    return (
        <div className="table__container scroll-icon">
            <table className='document-rows__table table table-responsive-md table-hover'>
            <thead>
            <tr>
                <th>
                <Form.Check
                    id={'doc-check-all'}
                    custom
                    type="checkbox"
                    label=""
                    className='mt-2 mb-n1'
                    onChange={(event: any) => props.onRowSelect(null, event.target.checked)}
                    checked={!!documentRows.length && props.selectedRows?.length === documentRows.length}
                />
                </th>
                <th>Arve</th>
                <th className="sort-down-up-hover">
                    <div className="d-flex align-items-center" onClick={() => handleSortClick(IDocumentRowSortFields.DOCUMENT_DATE)}>
                    <span>Kuupäev</span>
                    <SortIcons
                        sortedByField={sortedByField}
                        sortDirection={sortDirection}
                        currentSortColumn={IDocumentRowSortFields.DOCUMENT_DATE}/>
                    </div>
                </th>
                <th className="sort-down-up-hover">
                    <div className="d-flex align-items-center" onClick={() => handleSortClick(IDocumentRowSortFields.LOCATION)}>
                    <span>Asukoht</span>
                    <SortIcons
                        sortedByField={sortedByField}
                        sortDirection={sortDirection}
                        currentSortColumn={IDocumentRowSortFields.LOCATION}/>
                    </div>
                </th>
                <th className="sort-down-up-hover mw-card-nr">
                    <div className="d-flex align-items-center" onClick={() => handleSortClick(IDocumentRowSortFields.REMOTE_CARD_ID)}>
                    <span>Kliendikaart</span>
                    <SortIcons
                        sortedByField={sortedByField}
                        sortDirection={sortDirection}
                        currentSortColumn={IDocumentRowSortFields.REMOTE_CARD_ID}/>
                    </div>
                </th>
                <th className="sort-down-up-hover">
                    <div className="d-flex align-items-center" onClick={() => handleSortClick(IDocumentRowSortFields.CARD_NAME)}>
                    <span>Nimi</span>
                    <SortIcons
                        sortedByField={sortedByField}
                        sortDirection={sortDirection}
                        currentSortColumn={IDocumentRowSortFields.CARD_NAME}/>
                    </div>
                </th>
                <th>Autonumber</th>
                <th>Odomeetri näit</th>          
                <th>Kauba nimetus</th>
                <th>Hind</th>
                <th>Kogus</th>
                <th>Summa</th>
                <th>Summa KM-ta</th>
                <th>Käibemaks</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
                {isRequesting ?
                <tr>
                    <td colSpan={13} className="spinner-cell">
                        <div className="p-4 w-100 max-w-100vw d-flex align-items-center justify-content-center">
                            <Spinner animation="grow" />
                        </div>
                    </td>
                </tr> :
                tableRows}
            </tbody>
            <tfoot>
            {pageResponse ? <tr>
                <td colSpan={13}>
                    <div className="pagination-wrapper">
                        <Pagination
                            locale={locale}
                            current={pageResponse.number + 1}
                            total={pageResponse.totalElements}
                            pageSize={pageResponse.size}
                            prefixCls={"pagination"}
                            onChange={props.onPageChange}
                            showSizeChanger={false}
                            hideOnSinglePage={true}
                        />
                    </div>
                </td>
            </tr> : null}
            </tfoot>
        </table>
        </div>
    )
}